import { render, staticRenderFns } from "./RemindersModal.vue?vue&type=template&id=5a161ceb&"
import script from "./RemindersModal.vue?vue&type=script&lang=js&"
export * from "./RemindersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports